module.exports = __webpack_public_path__ + "img/search-salon-hair-2020.19ba289f.jpg";